import * as preferencesActions from './actions';
import preferencesReducer from './reducer';
import * as preferencesTypes from './types';
import * as preferencesUtils from './utils';

export {preferencesActions, preferencesTypes, preferencesUtils};

export default preferencesReducer;
